// navigationService.js
let navigationCallback = null;

// This will be called in your AppRoutes component
export const initializeNavigationService = (navigate) => {
    navigationCallback = navigate;
};

// This can be used anywhere in your application
export const navigateTo = (path, options = {}) => {
    if (!navigationCallback) {
        console.warn('Navigation service not initialized. Navigation may not work as expected.');
        return;
    }

    navigationCallback(path, {
        replace: options.replace || false,
        state: options.state || {}
    });
};

// Optional: Add more navigation helpers
export const redirectTo = (path, state = {}) => {
    navigateTo(path, { replace: true, state });
};

export const goBack = () => {
    if (!navigationCallback) return;
    window.history.back();
};
